import { now } from "./skyward.base.time";

export function setupClock(dateContainer: JQuery<HTMLElement>, timeContainer: JQuery<HTMLElement>)
{
    updateClock(dateContainer, timeContainer);

    setInterval(() =>
    {
        updateClock(dateContainer, timeContainer);
    }, 1000);
}

export function formatTime(time: Date, options: { useSeconds?: boolean })
{
    const defaults =
    {
        useSeconds: false
    };

    const settings = { ...defaults, ...options };

    let hours = time.getHours();
    let minutes = time.getMinutes();
    const isPM = hours >= 12;

    hours = hours % 12;
    hours = hours === 0 ? 12 : hours;

    const convertedHours = hours.toString().padStart(2, '0');
    const convertedMinutes = minutes.toString().padStart(2, '0');

    let formattedTime = `${convertedHours}:${convertedMinutes}`;

    if (settings.useSeconds)
    {
        const seconds = time.getSeconds();
        const convertedSeconds = seconds.toString().padStart(2, '0');
        formattedTime += `:${convertedSeconds}`;
    }

    return `${formattedTime} ${isPM ? 'PM' : 'AM'}`;
}

function updateClock(dateContainer: JQuery<HTMLElement>, timeContainer: JQuery<HTMLElement>)
{
    const time: Date = now();
    const formattedTime = formatTime(time, { useSeconds: true });
    dateContainer.text(time.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }));
    timeContainer.text(formattedTime);
}